import React from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';

const formatCamelCase = (text) => {
  if (!text) return "";
  return text
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, char => char.toUpperCase());
};

export const getProjectColumns = ({ handleEdit, handleDelete, hasPermission }) => [
  {
    accessorKey: 'index',
    header: '#',
    cell: (info) => <span className="text-white opacity-50">{info.row.index + 1}</span>,
    enableSorting: false, 
  },
  {
    accessorKey: 'projectName',
    header: 'Project Title',
    cell: (info) => <span className="text-white fw-bold">{info.getValue()}</span>,
  },
  {
    accessorKey: 'projectType',
    header: 'Type',
    cell: (info) => <span className="text-white opacity-75">{formatCamelCase(info.getValue())}</span>,
  },
  {
    accessorKey: 'projectDirectorName',
    header: 'Director',
    cell: (info) => <span className="text-white opacity-75">{info.getValue()}</span>,
  },
  {
    accessorKey: 'projectStartDate',
    header: 'Start Date',
    cell: (info) => <span className="small text-white opacity-75">{info.getValue()}</span>,
  },
  {
    accessorKey: 'projectEndDate',
    header: 'End Date',
    cell: (info) => <span className="small text-white opacity-75">{info.getValue()}</span>,
  },
  {
    accessorKey: 'rolesCount',
    header: 'Roles',
    cell: (info) => <span className="text-info fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'auditionsCount',
    header: 'Auditions',
    cell: (info) => <span className="text-warning fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'pendingCount',
    header: 'Pending',
    cell: (info) => <span className="text-primary fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'selectedCount',
    header: 'Selected',
    cell: (info) => <span className="text-success fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'rejectedCount',
    header: 'Rejected',
    cell: (info) => <span className="text-danger fw-bold">{info.getValue() || 0}</span>,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: (info) => {
      const val = info.getValue();
      let statusClass = 'pmp-status-active';
      if (val === 'Expired') statusClass = 'pmp-status-expired';
      if (val === 'Inactive') statusClass = 'pmp-status-inactive';

      return (
        <span className={`pmp-status-tag ${statusClass}`}>
          {val}
        </span>
      );
    },
  },
  {
    id: 'actions',
    header: () => <div style={{ textAlign: "center", width: "100%" }}>ACTIONS</div>,
    enableSorting: false, 
    cell: (info) => (
      <div className="pmp-action-btn-group">
        {hasPermission('Projects', 'Edit') && (
          <button 
            type="button" 
            className="pmp-btn-action pmp-btn-edit" 
            title="Edit Project"
            onClick={() => handleEdit(info.row.original.id)}
          >
            <FaEdit size={14} color="#ffffff" />
          </button>
        )}
        {hasPermission('Projects', 'Delete') && (
          <button 
            type="button" 
            className="pmp-btn-action pmp-btn-delete" 
            title="Delete Project"
            onClick={() => handleDelete(info.row.original)}
          >
            <FaTrash size={14} color="#ffffff" />
          </button>
        )}
      </div>
    ),
  }
];
